import apiClient from "@/services/ApiClient"

export function kanbanActions(serviceName) {
  return {
    getKanbanColumns(id) {
      return apiClient.get(`/${serviceName}/kanban-columns/list/${id}`)
    },
    addKanbanColumn(id) {
      return apiClient.post(`/${serviceName}/kanban-columns/create`, {
        id: id,
      })
    },
    removeKanbanColumn(column_id) {
      return apiClient.delete(`/${serviceName}/kanban-columns/delete/${column_id}`)
    },
    moveKanbanColumn(data) {
      const column_id = data.id
      return apiClient.post(
        `/${serviceName}/kanban-columns/move/${column_id}`,
        data
      )
    },
    updateColumnTitle(column_id, nom) {
      return apiClient.put(
        `/${serviceName}/kanban-columns/rename/${column_id}`,
        { nom: nom }
      )
    },
    getGlobals() {
      return apiClient.get(`/${serviceName}/kanban-globals`)
    },
    filterGlobals(data) {
      return apiClient.post(`/${serviceName}/kanban-globals`, data)
    },
    moveKanbanItem(data) {
      return apiClient.post(`/${serviceName}/kanban-column-items`, data)
    },
    getResum(id) {
      return apiClient.get(`/${serviceName}/${id}/kanban`)
    },
  }
}
